import { render, staticRenderFns } from "./DossierEditQuickCreateCopyModal.vue?vue&type=template&id=38b43ac0&"
import script from "./DossierEditQuickCreateCopyModal.vue?vue&type=script&lang=ts&"
export * from "./DossierEditQuickCreateCopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b43ac0')) {
      api.createRecord('38b43ac0', component.options)
    } else {
      api.reload('38b43ac0', component.options)
    }
    module.hot.accept("./DossierEditQuickCreateCopyModal.vue?vue&type=template&id=38b43ac0&", function () {
      api.rerender('38b43ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierEditQuickCreateCopyModal.vue"
export default component.exports